import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../logoMovie.png";

import "./Navbar.css";



export default function NavBar() {
  const [state, setState] = useState({
    home: false,
    favourites: false,
    movies: false,
    profile: false,
    help: false,
    settings: false,
    password: false,
    signout: false,
  });
  
  const [isHovering, setIsHovering] = useState(false);


  const handleMouseOver = () => {
    setIsHovering(true);
  }

  const handleMouseOut = () => {
    setIsHovering(false);
  }

  return (
    <nav className="navigation">
      <ul>
        <li id="home" className={isHovering ? null : (state.home ? "active" : null)} 
        onClick={ () => setState({home: !state.home}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <NavLink exact to="/movies">
            <span className="icon"><ion-icon name="home-outline"></ion-icon></span>
            <span className="title">Inicio</span>
            </NavLink>
        </li>
        <li id="favorites" className={isHovering ? null : (state.favourites ? "active" : null)} 
        onClick={ () => setState({favourites: !state.favourites}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <NavLink to="/favs">
            <span className="icon"><ion-icon name="star-outline"></ion-icon></span>
            <span className="title">Favoritas</span>
          </NavLink>
        </li>
        <li id="movies" className={isHovering ? null : (state.movies ? "active" : null)}
        onClick={ () => setState({movies: !state.movies}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <NavLink to="/movie/:id" >
            <span className="icon"><ion-icon name="film-outline"></ion-icon></span>
            <span className="title">Peliculas</span>
          </NavLink>
        </li>
        <li id="profile" className={isHovering ? null : (state.profile ? "active" : null)}
        onClick={ () => setState({profile: !state.profile}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <a href="#">
            <span className="icon"><ion-icon name="person-outline"></ion-icon></span>
            <span className="title">Perfil</span>
          </a>
        </li>
        <li id="help" className={isHovering ? null : (state.help ? "active" : null)}
        onClick={ () => setState({help: !state.help}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <a href="#">
            <span className="icon"><ion-icon name="help-outline"></ion-icon></span>
            <span className="title">Ayuda</span>
          </a>
        </li>
        <li id="settings" className={isHovering ? null : (state.settings ? "active" : null)}
        onClick={ () => setState({settings: !state.settings}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <a href="#">
            <span className="icon"><ion-icon name="settings-outline"></ion-icon></span>
            <span className="title">Configuración</span>
          </a>
        </li>
        <li id="password" className={isHovering ? null : (state.password ? "active" : null)}
        onClick={ () => setState({password: !state.password}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <a href="#">
            <span className="icon"><ion-icon name="lock-closed-outline"></ion-icon></span>
            <span className="title">Contraseña</span>
          </a>
        </li>
        <li id="signout" className={isHovering ? null : (state.signout ? "active" : null)}
        onClick={ () => setState({signout: !state.signout}) }
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}>
          <a href="#">
            <span className="icon"><ion-icon name="log-out-outline"></ion-icon></span>
            <span className="title">Cerrar Sesión</span>
          </a>
        </li>
      </ul>
    </nav>
  );
}
